
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import StreetView from "../components/streetView";
import Footer from "../components/footer";

function StreetViewPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <StreetView /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default StreetViewPage;
